import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindBrandDocumentContent($signAdvantageFilter: String!, $brandAdvantageFilter: String!, $cornerFilter: String!)
{
  cmsSignData: queryEnseigneContents(top: 1, skip: 0, filter: $signAdvantageFilter) {
    data {
      pageTitle {
        iv
      }
      advantageTitle {
        iv
      }
      advantage {
        iv
      }
      mention: avantageMention {
        iv
      }
      mentionFontSize: avantageMentionFontSize {
        iv
      }
      mentionTextColor: avantageMentionTextColor {
        iv
      }
      logo {
        iv {
          url
          fileSize
        }
      }
      url {
        iv
      }
    }
  }
  cmsBrandData: queryMarqueContents(top: 1, skip: 0, filter: $brandAdvantageFilter) {
    data {
      advantageTitle {
        iv
      }
      advantage {
        iv
      }
      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }
      url {
        iv
      }
    }
  }
  cmsBrandCorner: queryCornerMarqueContents(top: 1, skip: 0, filter: $cornerFilter) {
    data {
      signId {
        iv
      }
      picture {
        iv {
          url
          fileSize
        }
      }
      link {
        iv
      }
    }
  }
}
`,
]);
